import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import VideosCreateEditForm from './Components/VideosCreateEditForm';
import VideosApi from './VideosApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: VideosCreateEditForm,
                getCreate: VideosApi.create,
                getClone: VideosApi.getOne,
                defaults: {},
                successMessage: "Videos Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}